<template>
    <div class="container">
        <div class="rights-tit">
            <div class="top-title">我的权益</div>
            <div class="top-rightarea">
                <div class="top-desc" @click="allBenefitClick">全部权益</div>
                <div class="top-arrow"></div>
            </div>
        </div>
        <div
            class="bannerIC"
            v-if="bannerInfo && bannerInfo.bannerUrl"
            :style="{ backgroundImage: `url(${bannerInfo.bannerUrl})` }"
            @click="bannerClick"
        ></div>
        <div class="crad-area">
            <div
                :class="['card-item', item.type === 2 ? 'item-bg-two' : 'item-bg-one']"
                v-for="(item, index) in currScoreData"
                :key="index"
                @click="gradeItemClick(item)"
            >
                <div class="card-tit">{{ item.title }}</div>
                <div
                    :class="
                        benefitStyleOne.indexOf(item.benefitKey) > -1
                            ? 'card-value1'
                            : 'card-value2'
                    "
                >
                    {{ item.desc }}
                </div>
                <div class="card-alert" v-if="item.type != 2">
                    {{ item.type === 1 ? '仅限今日' : '新人专享' }}
                </div>
                <div :class="buntStyle(item)">
                    {{ butnTitel(item) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';
export default {
    mixins: [homemixin],
    props: ['currScoreData', 'scoreInfoData', 'switch3DCat'],
    data() {
        return {
            benefitStyleOne: ['qyr', 'hfq', 'hkq', 'mxq', 'eleme', 'swlb', 'zkq'],
            benefitGuidArr: ['qyr', 'hfq', 'hkq', 'mxq', 'eleme', 'swlb', 'shqy', 'fdqy', 'zkq'],
            bannerInfo: null,
            awardStatus: 0 // 奖品状态未开始-1，未领取-10，已领取-20
        };
    },
    watch: {
        currScoreData: {
            deep: true,
            immediate: true,
            handler: function(newV, oldV) {
                this.getBenefitDayBanner();
                this.getAwardStatusAndGray();
                if (newV) {
                    newV.forEach(item => {
                        this.POINT('h5_element_imp', {
                            page: 'super-成长权益页',
                            tgt_event_id: 'h5_ACT_privilege_grade',
                            tgt_name: 'h5-ACT-成长权益-等级权益',
                            param: this.scoreInfoData.totalScore,
                            param1: this.gradeType(item),
                            param2: item.title,
                            param3: item.desc,
                            param4: this.butnTitel(item),
                            param5: this.scoreInfoData.allScore,
                            param6: this.param6Value(item),
                            param7: this.$route.query.source,
                            param8: this.switch3DCat ? '是' : '否'
                        });
                    });
                }
            }
        }
    },
    created() {},
    methods: {
        async getBenefitDayBanner() {
            const { Result, Content } = await this.$http.getBenefitDayBanner({});
            if (Result === 200) {
                this.bannerInfo = Content;
            }
        },
        async getAwardStatusAndGray() {
            const { Result, Content } = await this.$http.getAwardStatusAndGray({});
            if (Result === 200) {
                console.log('getAwardStatusAndGray', Content);
                this.awardStatus = Content.hitGray ? Content.awardStatus : 0;
            }
        },
        bannerClick() {
            if (this.bannerInfo && this.bannerInfo.linkUrl) {
                this.openLink(this.bannerInfo.linkUrl);
            }
        },
        gradeItemClick(item) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-等级权益',
                tgt_event_id: 'h5_ACT_privilege_grade',
                param: this.scoreInfoData.totalScore,
                param1: this.gradeType(item),
                param2: item.title,
                param3: item.desc,
                param4: this.butnTitel(item),
                param5: this.scoreInfoData.allScore,
                param6: this.param6Value(item),
                param7: this.$route.query.source,
                param8: this.switch3DCat ? '是' : '否'
            });
            this.$emit('OnCurrBenefitClick', item);
        },
        gradeType(value) {
            if (value.benefitKey === 'fdqy') {
                return '浮动权益';
            } else if (value.benefitKey === 'xsqy') {
                return '新人权益';
            } else {
                return '已解锁';
            }
        },
        param6Value(value) {
            if (['xsqy', 'fdqy'].indexOf(value.benefitKey) > -1) {
                return value.couponBatchNo;
            }
            return '';
        },
        // 按钮文案
        // eslint-disable-next-line complexity
        butnTitel(item) {
            if (item.benefitKey === 'edcz') {
                return '去查看';
            } else if (item.benefitKey === 'eleme' || item.benefitKey === 'shqy') {
                return '领取';
            } else if (item.benefitKey === 'hxyk') {
                return '去使用';
            } else if (item.benefitKey === 'kfzx') {
                return '去使用';
            } else if (item.benefitKey === 'swlb') {
                return item.benefitStatus === 20 ? '去查看' : '领取';
            } else if (item.benefitKey === 'qyr') {
                let butnTit = '';
                // awardStatus: 奖品状态未开始-1，未领取-10，已领取-20
                switch (item.benefitStatus) {
                    case 1:
                        if (this.awardStatus === 0) {
                            butnTit = '每月18日';
                        } else {
                            butnTit =
                                this.awardStatus === 1
                                    ? '每月18日'
                                    : this.awardStatus === 20
                                        ? '去使用'
                                        : '去领取';
                        }
                        break;
                    case 10: {
                        butnTit = '去领取';
                        break;
                    }
                    case 20: {
                        butnTit =
                            this.awardStatus === 10
                                ? '去领取'
                                : this.awardStatus === 20
                                    ? '去使用'
                                    : '去领取';
                        break;
                    }
                    case 21:
                        butnTit = this.awardStatus === 10 ? '去领取' : '去使用';
                        break;
                    case 22:
                        butnTit = this.awardStatus === 10 ? '去领取' : '下月可领';
                        break;

                    default:
                        butnTit = '去领取';
                        break;
                }
                return butnTit;
            } else if (['hfq', 'hkq', 'mxq'].indexOf(item.benefitKey) > -1) {
                if (item.benefitStatus === 20) {
                    return item.receiveMode === 1 ? '已领取' : '下月可领';
                } else if (item.benefitStatus === 21) {
                    return '去使用';
                } else if (item.benefitStatus === 22) {
                    return item.receiveMode === 1 ? '已使用' : '下月可领';
                } else {
                    return '领取';
                }
            } else if (item.benefitKey === 'zkq') {
                return item.buttonText;
            } else if (['fdqy', 'xsqy'].indexOf(item.benefitKey) > -1) {
                let benSta = item.benefitStatus;
                return benSta === 10
                    ? '领取'
                    : benSta === 20
                        ? '已领取'
                        : benSta === 21
                            ? '去使用'
                            : benSta === 22
                                ? '已使用'
                                : benSta === 30
                                    ? '已过期'
                                    : '';
            } else {
                return '';
            }
        },
        buntStyle(item) {
            if (['edcz', 'hxyk', 'kfzx'].indexOf(item.benefitKey) > -1) {
                return 'butn-with-df';
            } else if (['shqy', 'eleme'].indexOf(item.benefitKey) > -1) {
                return 'butn-with-df';
            } else if (item.benefitKey === 'swlb') {
                return 'butn-with-df';
            } else if (item.benefitKey === 'qyr') {
                switch (item.benefitStatus) {
                    case 1: {
                        return this.awardStatus === 10 || this.awardStatus === 20
                            ? 'butn-with-df'
                            : 'butn-with-gray';
                    }
                    case 10: {
                        return 'butn-with-df';
                    }
                    case 21: {
                        return 'butn-with-df';
                    }
                    case 22: {
                        return this.awardStatus === 10 ? 'butn-with-df' : 'butn-with-gray';
                    }
                    default:
                        return 'butn-with-df';
                }
                // return item.benefitStatus === 1 || item.benefitStatus === 22
                //     ? 'butn-with-gray'
                //     : 'butn-with-df';
            } else if (['hfq', 'hkq', 'mxq', 'zkq'].indexOf(item.benefitKey) > -1) {
                if (item.benefitStatus === 20 || item.benefitStatus === 22) {
                    return 'butn-with-gray';
                } else {
                    return 'butn-with-df';
                }
            } else if (['fdqy', 'xsqy'].indexOf(item.benefitKey) > -1) {
                if (
                    item.benefitStatus === 20 ||
                    item.benefitStatus === 22 ||
                    item.benefitStatus === 30
                ) {
                    return 'butn-with-gray-top';
                } else {
                    return 'butn-with-df-top';
                }
            }
        },
        allBenefitClick() {
            this.$emit('OnAllBenefitClick');
        }
    }
};
</script>

<style lang="less" scoped>
@asserts: '../../../../assets/iconV2.5/';
@asserts_4_0: '../../../../assets/iconV4.0/';
.container {
    border-radius: 16px 16px 0 0;
    margin-top: -8px;
    padding-top: 24px;
    background-color: #fff;
    .rights-tit {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 4px 18px 0;
        line-height: 18px;
        .top-title {
            color: #002a3c;
            font-size: 18px;
            font-weight: bold;
        }
        .top-rightarea {
            display: flex;
            flex-direction: row;
            align-items: center;
            .top-desc {
                color: #254d5e;
                font-size: 13px;
                // font-family: fzlt;
            }
            .top-arrow {
                margin-left: 4px;
                width: 6px;
                height: 10px;
                background-size: 100% 100%;
                background-image: url('@{asserts}/mygrade-arrow@2x.png');
            }
        }
    }
    .bannerIC {
        margin: 20px 16px 0;
        width: 343px;
        height: 64px;
        background-size: 100% 100%;
    }
    .crad-area {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        padding: 19px 10px 6px 17px;
        overflow-x: auto;
        overflow-y: hidden;
        .item-bg-one {
            background-image: url('@{asserts_4_0}/floatCoupon-card@2x.png');
        }
        .item-bg-two {
            background-image: url('@{asserts_4_0}/coupon-card@2x.png');
        }
        .card-item {
            width: 78px;
            min-width: 78px;
            height: 108px;
            background-size: 100% 100%;
            text-align: center;
            margin-right: 4px;
            .card-tit {
                margin-top: 7px;
                font-size: 12px;
                line-height: 13px;
                color: #fff;
                font-weight: bold;
            }
            .card-value1 {
                margin-top: 18px;
                color: #3f5862;
                font-size: 14px;
                line-height: 13px;
                font-weight: bold;
            }
            .card-value2 {
                margin-top: 18px;
                color: #3f5862;
                font-size: 14px;
                line-height: 13px;
                font-weight: bold;
            }
            .card-alert {
                margin-top: 4px;
                color: #ff4d00;
                font-size: 12px;
                transform: scale(0.75);
                line-height: 11px;
            }
            .butn-with-df {
                margin: 18px 9px 0;
                width: 60px;
                height: 20px;
                border-radius: 10px;
                font-size: 11px;
                // font-family: fzlt_bold;
                font-weight: 400;
                line-height: 20px;
                background-image: url('@{asserts}/benefit-butn.gif');
                background-size: 100% 100%;
                color: #fff;
            }
            .butn-with-df-top {
                margin: 3px 9px 0;
                width: 60px;
                height: 20px;
                border-radius: 10px;
                font-size: 11px;
                // font-family: fzlt_bold;
                font-weight: 400;
                line-height: 20px;
                background-image: url('@{asserts}/benefit-butn.gif');
                background-size: 100% 100%;
                color: #fff;
            }
            .butn-with-gray {
                margin: 20px 0 0;
                width: 100%;
                height: 20px;
                font-size: 12px;
                line-height: 17px;
                // font-family: fzlt_bold;
                font-weight: 400;
                color: #9faab5;
            }
            .butn-with-gray-top {
                margin: 5px 0 0;
                width: 100%;
                height: 20px;
                font-size: 12px;
                line-height: 17px;
                // font-family: fzlt_bold;
                font-weight: 400;
                color: #9faab5;
            }
        }
    }
}
</style>
